export enum RouteType {
  Internal = 'internal',
  External = 'external',
}
